<template>
    <div class="dv5-shared-carousel">
        <VueSlickCarousel v-if="view.length > 0" v-bind="settings" :key="forceUpdateOnResize">
            <slot
                name="slide"
                v-for="(slide, index) in view"
                :slide="slide"
                :slideClass="'custom-slide'"
            >
                <div class="custom-slide" :key="index">
                    <div class="example-card">{{slide.title}} {{index+1}}</div>
                </div>
            </slot>

            <template #prevArrow="arrowOption">
                <img class="" src="/internacional/public/office5/img/general-svg/arrow_left.svg" />
            </template>

            <template #nextArrow="arrowOption">
                <img class="" src="/internacional/public/office5/img/general-svg/arrow_right.svg" />
            </template>

            <template #customPaging="page">
                <div class="custom-dot"><span>{{page+1}}</span></div>
            </template>
        </VueSlickCarousel>
        <div v-else class="no-data">
            <h3>Nenhum dado encontrado!</h3>
        </div>
    </div>
</template>

<script>
export default {
    name: "lead-carousel",
    props: {
        'view': {
            type: Array,
            default: () => [
                { title: "Example slide" },
                { title: "Example slide" },
                { title: "Example slide" },
                { title: "Example slide" },
                { title: "Example slide" },
                { title: "Example slide" },
                { title: "Example slide" },
                { title: "Example slide" },
                { title: "Example slide" },
            ]
        },
        dots: {
            type: Boolean,
            default: false
        },
        infinite: {
            type: Boolean,
            default: true
        },
        speed: {
            type: Number,
            default: 500
        },
        initialSlide: {
            type: Number,
            default: 0
        },
        arrows: {
            type: Boolean,
            default: true
        },
        slidesToShow: {
            type: Number,
            default: 3
        },
        slidesToScroll: {
            type: Number,
            default: 3
        }, // tamanho do salto
        rows: {
            type: Number,
            default: 1
        },
        swipe: {
            type: Boolean,
            default: true
        },
        swipeToSlide: {
            type: Boolean,
            default: true
        },
        responsive: {
            type: Array,
            default: function () {
                return [
                    {
                        "breakpoint": 100000,
                        "settings": {
                            "slidesToShow": 8,
                            "slidesToScroll": 8,
                            'cols': 7,
                            'rows': 2,
                            'dots': false
                        }
                    },
                    {
                        "breakpoint": 1920,
                        "settings": {
                            "slidesToShow": 6,
                            "slidesToScroll": 6,
                            'cols': 6,
                            'rows': 2,
                            'dots': false
                        }
                    },
                    {
                        "breakpoint": 1620,
                        "settings": {
                            "slidesToShow": 5,
                            "slidesToScroll": 5,
                            'cols': 5,
                            'rows': 2,
                            'dots': false
                        }
                    },
                    {
                        "breakpoint": 1420,
                        "settings": {
                            "slidesToShow": 5,
                            "slidesToScroll": 5,
                            'cols': 4,
                            'rows': 2,
                            'dots': false
                        }
                    },
                    {
                        'breakpoint': 1366,
                        'settings': {
                            'slidesToShow': 4,
                            'slidesToScroll': 4,
                            'cols': 3,
                            'rows': 2,
                            'dots': false
                        }
                    },
                    {
                        "breakpoint": 1266,
                        "settings": {
                            "slidesToShow": 5,
                            "slidesToScroll": 5,
                            'cols': 3,
                            'rows': 2,
                            'dots': false
                        }
                    },
                    {
                        "breakpoint": 950,
                        "settings": {
                            "slidesToShow": 5,
                            "slidesToScroll": 5,
                            'cols': 3,
                            'rows': 2,
                            'dots': false
                        }
                    },
                    {
                        "breakpoint": 850,
                        "settings": {
                            "slidesToShow": 5,
                            "slidesToScroll": 5,
                            'cols': 3,
                            'rows': 2,
                            'dots': false
                        }
                    },
                    {
                        'breakpoint': 750,
                        'settings': {
                            "slidesToShow": 5,
                            "slidesToScroll": 5,
                            'cols': 3,
                            'rows': 2,
                            'arrows': true,
                            'dots': false
                        }
                    },
                    {
                        'breakpoint': 650,
                        'settings': {
                            "slidesToShow": 4,
                            "slidesToScroll": 4,
                            'rows': 2,
                            'arrows': true,
                            'dots': false
                        }
                    },
                    {
                        'breakpoint': 550,
                        'settings': {
                            "slidesToShow": 5,
                            "slidesToScroll": 5,
                            'rows': 2,
                            'arrows': true,
                            'dots': false
                        }
                    },
                    {
                        'breakpoint': 450,
                        'settings': {
                            "slidesToShow": 4,
                            "slidesToScroll": 4,
                            'rows': 2,
                            'arrows': true,
                            'dots': false
                        }
                    },
                    {
                        'breakpoint': 350,
                        'settings': {
                            "slidesToShow": 3,
                            'rows': 2,
                            'arrows': true,
                            'dots': false
                        }
                    },
                    {
                        'breakpoint': 200,
                        'settings': {
                            "slidesToShow": 2,
                            'rows': 2,
                            'arrows': false,
                            'dots': false
                        }
                    },
                ]
            }
        },
    },
    data(){
        return {
            settings: {
                dots: this.dots,
                infinite: this.infinite,
                speed: this.speed,
                initialSlide: this.initialSlide,
                slidesToShow: this.slidesToShow,
                slidesToScroll: this.slidesToScroll, // tamanho do salto
                rows: this.rows,
                swipe: this.swipe,
                swipeToSlide: this.swipeToSlide,
                arrows: this.arrows,

                // autoplay: true,
                // autoplaySpeed: 1500,
                // pauseOnDotsHover: true,
                // pauseOnFocus: true,
                // pauseOnHover: true

                dotsClass: 'custom-dots slick-dots',
                "responsive": this.responsive,
            },
            forceUpdateOnResize: Math.round(Math.random() * 1000)
        }
    },
    methods: {
        onResize(){ // force update dots on window resize
            this.forceUpdateOnResize = Math.round(Math.random() * 1000)
        }
    },
    created(){
    },
    mounted(){
        this.onResize()
        window.addEventListener("resize", this.onResize);
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/delete-account/components/lead-carousel.vue